import React from 'react';

export interface AuthenticationContextType {
  authenticated: boolean; // Don't forget to update screens/SignOut
  isLoading: boolean;
  uid?: string;
  isSuperAdmin?: boolean;
  isWallboardUser?: boolean;
  wallBoardAccountId?: string;
  // Headless scheduled-report renderer identity (scoped, single-use token).
  // Distinct from the wallboard super-user: scoped to one account+report+run.
  isRenderUser?: boolean;
  renderRunId?: string;
  renderAccountId?: string;
  renderReportId?: string;
  renderTokenJti?: string;
}

const AuthenticationContext = React.createContext<AuthenticationContextType>({
  uid: 'NA',
  authenticated: false,
  isLoading: true,
});

export default AuthenticationContext;
